import useContract from './useContract';
import INoundles from '../contracts/INoundles.json';

const useNoundles = () =>
  useContract(process.env.NEXT_PUBLIC_NOUNDLES_CONTRACT_ADDRESS, INoundles.abi);

export default useNoundles;
